import { Box, Modal } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Close } from '@mui/icons-material';
import { useMemo, useState } from 'react';

import ModalStyle from '@/constants/ModalStyle';
import Pagination from '@/components/ui/Pagination/Pagination';
import { ArrowRightLeft, X } from 'lucide-react';

export default function FileExist(props) {
	const { open, onClose, onSave, files } = props;

	const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
	const [dataList, setDataList] = useState(files || []);

	const dataCount = files?.length;

	const onUpdate = (id, key, val) => {
		setDataList((prevState) => {
			const currState = prevState;
			const f = currState.findIndex((f) => f.id === id);
			if (f !== -1) {
				currState[f] = { ...currState[f], [key]: val };
			}
			return currState;
		});
	};

	const onSubmit = () => {
		onSave(dataList);
	};
	const columns = [
		{
			field: 'file',
			headerName: 'Filename',
			headerAlign: 'center',
			align: 'left',
			flex: 1,
			renderCell: (params) => {
				const { file } = params.row;
				return <span>{file.name}</span>;
			},
		},
		{
			field: 'id',
			headerName: 'Action',
			headerAlign: 'center',
			align: 'center',
			renderCell: (params) => {
				const { id } = params.row;
				return (
					<div className='flex items-center justify-center w-full h-full gap-4'>
						<button title="Ikke last opp" onClick={() => onUpdate(id, 'replace', 0)}>
							<X size={16} />
						</button>
						<button title='Overskriv eksisterende' onClick={() => onUpdate(id, 'replace', 1)}>
							<ArrowRightLeft size={16} color='var(--primary)' />
						</button>
					</div>
				);
			},
		},
	];
	const data = useMemo(() => {
		return dataList.filter((d) => d.id && d.error)
	}, [dataList])
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby='modal-project-relations'
			aria-describedby='modal-project-relations'
			className='w-full'
		>
			<Box sx={{ ...ModalStyle, top: '50svh' }} className='relative flex flex-col gap-4 w-[90%] md:w-[680px] h-auto'>
				<span className='mb-4 text-2xl modal-title'>Denne file finnes allerede i databasen</span>
				<button className='absolute text-4xl top-4 right-4' onClick={onClose}>
					<Close fontSize='inherit' sx={{ color: 'var(--primary)' }} />
				</button>

				<div className='flex w-full gap-4'>
					<DataGrid
						autoHeight
						rows={data}
						columns={columns}
						rowsPerPageOptions={[10, 20, 50]}
						className='mx-auto lg:max-w-[1600px] w-full h-full mt-0'
						disableColumnFilter
						disableColumnSelector
						disableDensitySelector
						disableToolbarButton
						disableRowSelectionOnClick
						slots={{
							pagination: Pagination,
						}}
						getRowId={(row) => row.id || row.postid}
						getRowClassName={(params) => {
							let cellClass = params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
							return cellClass;
						}}
						slotProps={{
							loadingOverlay: {
								variant: 'skeleton',
								noRowsVariant: 'skeleton',
							},
							pagination: {
								page: paginationModel.page,
							},
						}}
						onCellClick={(params, event) => {
							if (event.target.type === 'checkbox' || ['svg', 'path'].includes(event.target.tagName)) return;
						}}
						initialState={{
							pagination: { paginationModel: { pageSize: 10 } },
						}}
						rowCount={dataCount}
						paginationModel={paginationModel}
						paginationMode='client'
						onPaginationModelChange={(obj) => setPaginationModel(obj)}
					/>
				</div>
				<button
					className='w-auto ml-auto btn'
					onClick={() => {
						onSubmit();
					}}
				>
					Lagre
				</button>
			</Box>
		</Modal>
	);
}
